/**
 * @generated SignedSource<<9543a5f805238f0aea7e3ffa9dad0953>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserCardNew_GuildMemberships$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"UserCardNew_BadgeLink">;
    } | null | undefined;
  }>;
  readonly " $fragmentType": "UserCardNew_GuildMemberships";
};
export type UserCardNew_GuildMemberships$key = {
  readonly " $data"?: UserCardNew_GuildMemberships$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserCardNew_GuildMemberships">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserCardNew_GuildMemberships",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GuildMembershipsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GuildMembership",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "UserCardNew_BadgeLink"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GuildMembershipsConnection",
  "abstractKey": null
};

(node as any).hash = "b1595389357fddc9bf6839e03064ebfa";

export default node;
